import type { MixedItemDistResponse, PracticeTestExam } from "@memorang/types";

export const fetchPracticeTestExams = (_bundleId: string) => {
	return Promise.resolve({
		iconUrl: "",
		title: "",
		contents: [],
		freeTagIds: [],
		tags: [],
		exams: [] as PracticeTestExam[],
	} satisfies MixedItemDistResponse);
};
